import { Box, Grid, Typography } from "@mui/material";
import walletheadboxCover from "../../../../../media/images/walletheadboxCover.svg";
import CarTagView from "../../../../components/CarTag";
import { addCommas } from "@persian-tools/persian-tools";
import { useAppSelector } from "../../../../../hooks/useRedux";

export default function BannerBox() {
  const { fullName, stock } = useAppSelector((state) => state.user);

  return (
    <Box
      sx={{
        backgroundImage: `
              linear-gradient(180deg, rgba(23,131,240,0.804359243697479) 0%, rgba(23,131,240,1) 100%),
            url(${walletheadboxCover})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        borderRadius: "15px",
        height: "110px",
        justifyContent: "end",
        paddingX: "8px",
        paddingY: "8px",
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.20)",
      }}
    >
      <Grid
        sx={{
          height: "100%",
          justifyContent: "space-between",
        }}
        container
      >
        <Grid item xs={12}>
          <Box
            sx={{
              //   border: "1px solid gray",
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                // border: "1px solid gray",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "#fff",
                }}
              >
                {fullName}
              </Typography>
              <CarTagView />
            </Box>
            <Box
              sx={
                {
                  // border: "1px solid gray",
                }
              }
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                موجودی:
              </Typography>
              <Typography
                textAlign={"left"}
                sx={{
                  fontSize: "18px",
                  color: "#fff",
                }}
              >
                {addCommas(stock || 0)} ریال
              </Typography>
            </Box>
          </Box>
        </Grid>
        {/* <Grid item xs={3.5}>
          <Box
            sx={{
              borderRadius: "20px",
              height: "100%",
              width: "100%",
              backgroundColor: "#ECEFF1",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img width={57} height={64} src={silverShare} alt="" />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              اشتراک نقره‌ای
            </Typography>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
}
